import  { useState,useEffect } from 'react'
import {MwButton, MwSpinner} from '../../components/ui'
import {langObjType,objLangTextHandler,LangArrayToObjKeyValue} from '../../utils/global'
import {AiOutlineSave} from 'react-icons/ai'
import BaiscInfo from './forms/BaiscInfo'
import StockAndPrice from './forms/StockAndPrice'
import SEO from './forms/SEO'
import ProductLinks from './forms/ProductLinks'
import { useCurrent, useFetch, usePut, useUploadFile } from '../../hooks'
import ProductImages from './forms/ProductImages'
import {allowImgTypes} from '../../pages/products/constants'
import { useTranslation } from 'react-i18next'
import CardHeadeWithActions from '../ui/CardHeadeWithActions'
import {
    getProductTabClassName,
    PRODUCT_EDITOR_TABS,
    PRODUCT_FORM_PANEL_CLASS,
    PRODUCT_TAB_WRAPPER_CLASS,
    getProductTypeOptions,
} from './productUi'

const EditProduct = ({id,onHide,onProductCreated,setReloadProductList,setMode}) => {
    const [t] = useTranslation('global')

    const [tabActive,setTabActive] = useState('TabOne');
    const [errors,setErrors] = useState({});
    const {currentTenantId,currentCompanyId,currentLangId} = useCurrent();
    const {data:product,loading:loadingProduct} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/show/${id}`);
    const {data:resultPut,putData} = usePut();

    const [productCode,setProductCode] = useState('');
    const [productBarcode,setProductBarcode] = useState('');
    const [productFactoryCode,setProductFactoryCode] = useState('');
    const [productName,setProductName] = useState(langObjType());
    const [productDesc,setProductDesc] = useState(langObjType());
    const [productPrice,setProductPrice] = useState('');
    const [productTypeSelected,setProductTypeSelected] = useState();
    const [isActive,setIsActive] = useState(true);
    const [isShowOnWebsite,setIsShowOnWebsite] = useState(false);
    const [qty,setQty] = useState(0);
    const [cost,setCost] = useState();
    const [productMetaKeywords,setProductMetaKeywords] = useState(langObjType());
    const [productMetaDesc,setProductMetaDesc] = useState(langObjType());
    const [isStock,setIsStock] = useState(false);
    const [codeInStock,setCodeInStock] = useState();
    const [weightProduct,setWeightProduct] = useState();
    const [sizeProduct,setSizeProduct] = useState();
    const [uomSaleSelected,setUomSaleSelected] = useState();
    const [uomPurchaseSelected,setUomPurchesSelected] = useState();
    const [uomTemplateSelected,setTemplateUomSelected] = useState();

    const [genProductCode,setGenProductCode] = useState();
    const [productCategorySelected,setProductCategorySelected] = useState([]);
    const [productBrandSelected,setProductBrandSelected] = useState();
    const [productTags,setProductTags] = useState([]);

    const [productImages,setProductImages] = useState([]);
    const [productHomePicDefault,setProductImagesDefault] = useState();
    const {location:productHomePic,loading:loadingUploadHomePic,handleUpload:handleHomePicUpload} = useUploadFile(allowImgTypes,`products-${currentTenantId}`,'image')
    const {location:productImagesItem,loading:loadingUploadProductImages,handleMultiUploads:handleImagesItemUpload} = useUploadFile(allowImgTypes,`products-${currentTenantId}`,'image')
    const {resultdelete,loadingDeleting,handleDelete} = useUploadFile()

    useEffect(()=>{
        if(productImagesItem){
            setProductImages((state) => [...state,productImagesItem]);
        }
    },[productImagesItem])

    useEffect(() => {
        if(productHomePic) {
            setProductImagesDefault(productHomePic);
        }
    }, [productHomePic])

    const cancelHandle = () => {
        onHide && onHide();
    }

    const saveHandler = async (e) => {
        e.preventDefault(true);
        let errorObj = {};
        if(!productName[currentLangId]){
            errorObj = { ...errorObj, [`productName.${currentLangId}`] : t('validation.productNameRequired')};
        }
        if(!productTypeSelected){
            errorObj = {...errorObj, productType:t('validation.productTypeRequired')}
        }

        if(!productPrice){
            errorObj = {...errorObj, price:t('validation.productPriceRequired')}
            productName[currentLangId] && setTabActive('TabTwo');
        }else if(isNaN(parseFloat(productPrice))){
            errorObj = {...errorObj, price:t('validation.productPriceInvalid')}
            productName[currentLangId] && setTabActive('TabTwo');
        }
        
        if(Object.keys(errorObj).length !== 0 ){
            setErrors(errorObj)
            return
        }

        onHide && setReloadProductList && setReloadProductList(false)
        const _data = {
            productName : objLangTextHandler(productName) ,
            productDesc :objLangTextHandler(productDesc),
            productMetaKeywords :objLangTextHandler(productMetaKeywords),
            productMetaDesc :objLangTextHandler(productMetaDesc),
            productTags: JSON.stringify(productTags),
            productCategory: productCategorySelected?.map((item) => item['value'] ),
            productBrand:productBrandSelected?.value || null,
            productType: productTypeSelected?.value ,
            productHomePic: productHomePic || productHomePicDefault,
            productImages: productImages,
            productCode,
            productBarcode,
            productFactoryCode,
            codeInStock,
            weightProduct,
            sizeProduct,
            price:productPrice,
            qty:qty,
            cost: cost,
            uomTemplate:{
                id : uomTemplateSelected?.data.id,
                name : uomTemplateSelected?.data.name,
            },
            uomSale:{
                id: uomSaleSelected?.data.id,
                name: uomSaleSelected?.data.name,
                short_name: uomSaleSelected?.data.short_name,
                rate: uomSaleSelected?.data.rate,
            },
            uomPurchase:{
                id: uomPurchaseSelected?.data.id,
                name: uomPurchaseSelected?.data.name,
                short_name: uomPurchaseSelected?.data.short_name,
                rate: uomPurchaseSelected?.data.rate,
            },
            isStock,
            isShowOnWebsite,
            isActive,
            tenantId:currentTenantId,
            companyId : currentCompanyId
        };
        putData(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/update/${id}`,_data);
    }

    useEffect(()=>{
        if(resultPut){
            if(resultPut.status === 1){
                localStorage.setItem('isProductsUpdated','true')
                onHide && onHide();
                onHide ? onProductCreated() : setMode('List') ;
            }else if (resultPut.message) {
                setErrors((state) => ({ ...state, [`productName.${currentLangId}`] : resultPut.message }));
                setTabActive('TabOne');
            }
        }
    },[resultPut,currentLangId,onHide,onProductCreated,setMode])

    useEffect(()=>{
        if(product?.data && !loadingProduct ){
            const cats = product?.data.productCategory.map((cat)=>({
                label:LangArrayToObjKeyValue(cat.categoryName)?.[currentLangId],
                value:cat._id,
                lang:currentLangId,
                data:cat
            }))
            
            setProductName(LangArrayToObjKeyValue(product?.data.productName));
            setProductDesc(LangArrayToObjKeyValue(product?.data.productDesc));
            setIsShowOnWebsite(product?.data.isShowOnWebsite);
            setIsActive(product?.data.isActive);
            setProductCode(product?.data.productCode);
            setProductPrice(product?.data.price);
            setProductBarcode(product?.data.productBarcode)
            setProductFactoryCode(product?.data.productFactoryCode)
            setIsStock(product?.data.isStock)
            setCodeInStock(product?.data.codeInStock)
            setQty(product?.data.qty)
            product?.data?.uomTemplate && setTemplateUomSelected({
                label : product?.data?.uomTemplate?.name,
                value : product?.data?.uomTemplate?.id,
                data : product?.data?.uomTemplate
            })
            product?.data?.uomSale && setUomSaleSelected({
                label : product?.data?.uomSale?.short_name,
                value : product?.data?.uomSale?.id,
                data : product?.data?.uomSale,
            })
            product?.data?.uomPurchase && setUomPurchesSelected({
                label : product?.data?.uomPurchase?.short_name,
                value : product?.data?.uomPurchase.id,
                data : product?.data?.uomPurchase,
            })
            setCost(product?.data.cost)
            setWeightProduct(product?.data.weightProduct)
            setSizeProduct(product?.data.sizeProduct)
            setProductCategorySelected(cats)
            if (product?.data?.productBrand?._id) {
                setProductBrandSelected({
                    label:LangArrayToObjKeyValue(product?.data.productBrand?.brandName)?.[currentLangId],
                    value: product?.data.productBrand?._id,
                    lang: currentLangId,
                    data: product?.data.productBrand,
                });
            }
            if(product?.data?.productType){
                const selectedType = getProductTypeOptions(t).find((item) => item.value === product?.data?.productType)
                setProductTypeSelected(selectedType)
            }
            if(product?.data?.productHomePic){
                setProductImagesDefault(product?.data?.productHomePic)
            }
            if(product?.data?.productImages){
                setProductImages(product?.data?.productImages)
            }
            setProductTags(product?.data?.productTags ? JSON.parse(product?.data?.productTags) : [])
            setProductMetaKeywords(LangArrayToObjKeyValue(product?.data?.productMetaKeywords))
            setProductMetaDesc(LangArrayToObjKeyValue(product?.data?.productMetaDesc))
        }
    },[currentLangId,loadingProduct,product,t]);

    return (
        <div className='p-5'>
            { product && !loadingProduct ? <form>
                <CardHeadeWithActions title={t('product.editProduct')}>
                    {onHide && <MwButton inGroup={true} type='cancelBtn' onClick={cancelHandle}>{t('common.cancel')}</MwButton>}
                    <MwButton type="saveBtn" inGroup={true} onClick={() => setMode('List')}>{t('product.manageProducts')}</MwButton>
                    <MwButton inGroup={true} type='saveBtn' onClick={saveHandler}>{t('product.save')} <AiOutlineSave size={18}/></MwButton>
                </CardHeadeWithActions>
                <div className={`${PRODUCT_FORM_PANEL_CLASS} mt-3`}>
                    <ul className={PRODUCT_TAB_WRAPPER_CLASS}>
                        {PRODUCT_EDITOR_TABS.map((tab) => (
                            <li
                                key={tab.key}
                                onClick={() => setTabActive(tab.key)}
                                className={getProductTabClassName(tabActive === tab.key)}
                            >
                                {t(tab.labelKey)}
                            </li>
                        ))}
                    </ul>
                    <div id='content-body'>
                        {tabActive === 'TabOne' && (
                            <BaiscInfo
                                productName={productName}
                                setProductName={setProductName}
                                productDesc={productDesc}
                                setProductDesc={setProductDesc}
                                isShowOnWebsite={isShowOnWebsite}
                                setIsShowOnWebsite={setIsShowOnWebsite}
                                isActive={isActive}
                                setIsActive={setIsActive}
                                errors={errors}
                                productTypeSelected={productTypeSelected}
                                setProductTypeSelected={setProductTypeSelected}
                            />
                        )}
                        {tabActive === 'TabTwo' && (
                            <StockAndPrice
                                productCode={productCode}
                                setProductCode={setProductCode}
                                productPrice={productPrice}
                                setProductPrice={setProductPrice}
                                productBarcode={productBarcode}
                                setProductBarcode={setProductBarcode}
                                productFactoryCode={productFactoryCode}
                                setProductFactoryCode={setProductFactoryCode}
                                isStock={isStock}
                                setIsStock={setIsStock}
                                codeInStock={codeInStock}
                                setCodeInStock={setCodeInStock}
                                qty={qty}
                                setQty={setQty}
                                cost={cost}
                                setCost={setCost}
                                weightProduct={weightProduct}
                                setWeightProduct={setWeightProduct}
                                sizeProduct={sizeProduct}
                                setSizeProduct={setSizeProduct}
                                errors={errors}
                                uomSaleSelected={uomSaleSelected}
                                setUomSaleSelected={setUomSaleSelected}
                                uomPurchaseSelected={uomPurchaseSelected}
                                setUomPurchesSelected={setUomPurchesSelected}
                                uomTemplateSelected={uomTemplateSelected}
                                setTemplateUomSelected={setTemplateUomSelected}
                            />
                        )}
                        {tabActive === 'TabThree' && (
                            <ProductLinks
                                productCategorySelected={productCategorySelected}
                                setProductCategorySelected={setProductCategorySelected}
                                productBrandSelected={productBrandSelected}
                                setProductBrandSelected={setProductBrandSelected}
                                productTags={productTags}
                                setProductTags={setProductTags}
                                genProductCode={genProductCode}
                                setGenProductCode={setGenProductCode}
                                setProductCode={setProductCode}
                                productCode={productCode}
                            />
                        )}
                        {tabActive === 'TabFour' && (
                            <SEO
                                productMetaKeywords={productMetaKeywords}
                                setProductMetaKeywords={setProductMetaKeywords}
                                productMetaDesc={productMetaDesc}
                                setProductMetaDesc={setProductMetaDesc}
                            />
                        )}
                        {tabActive === 'TabFive' && (
                            <ProductImages
                                productHomePic={productHomePic}
                                productHomePicDefault={productHomePicDefault}
                                setProductImagesDefault={setProductImagesDefault}
                                loadingUploadHomePic={loadingUploadHomePic}
                                handleHomePicUpload={handleHomePicUpload}
                                productImages={productImages}
                                setProductImages={setProductImages}
                                productImagesItem={productImagesItem}
                                loadingUploadProductImages={loadingUploadProductImages}
                                handleImagesItemUpload={handleImagesItemUpload}
                                resultdelete={resultdelete}
                                loadingDeleting={loadingDeleting}
                                handleDelete={handleDelete}
                            />
                        )}
                    </div>
                </div>
            </form> : <MwSpinner/> }
        </div>
    )
}

export default EditProduct
